// extracted by mini-css-extract-plugin
export default {"buttons":"Details_buttons__O14pB"};